import React, { Component } from "react";
import { Button } from "react-bootstrap-buttons";
import { Form, Formik } from "formik";
import CustomPostSelector from "./CustomPostSelector";

class AniPosterModal extends Component {
  constructor(props) {
    super(props);
    const first = props.aniPosterOptions?.[0];
    this.state = {
      // each option already carries animated_poster_id from the API
      selectedOption: first ? first.animated_poster_id : null,
    };
  }

  cancelModal = () => {
    this.props.cancelModal();
  };

  handleSubmit = (values, actions) => {
    if (this.state.selectedOption) {
      this.props.generateAniPoster(this.state.selectedOption);
    }
    actions.setSubmitting(false);
    this.props.cancelModal();
  };

  render() {
    const rawOptions = this.props.aniPosterOptions;
    const aniPosterOptions = Array.isArray(rawOptions) ? rawOptions : [];

    // CustomPostSelector expects { key: animated_poster_id, name, img }
    const selectorOptions = aniPosterOptions.reduce((acc, po) => {
      acc[po.animated_poster_id] = { name: po.name, img: po.img };
      return acc;
    }, {});

    return (
      <div>
        <div className="modal-backdrop bg-secondary opacity6" />
        <div className="modal d-inline-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content pl-5 pr-5 pt-3 pb-3 m-auto bg--gray1">
              <Formik enableReinitialize onSubmit={this.handleSubmit} initialValues={{}}>
                {({ isSubmitting }) => (
                  <Form>
                    <div className="modal-body modal__print-poster--body-height px-0 ml-0 bg--gray1">
                      <div className="m-auto bg--gray1 w-100">
                        <div className="row align-items-start bg--gray1 w-100 h-100">
                          <div className="w-100">
                            <div className="bg--gray1">
                              <div className="h5">Select animated poster:</div>
                              <br />
                              <div className="d-flex flex-column align-items-center">
                                {aniPosterOptions.length === 0 ? (
                                  <p className="text--gray11">
                                    No poster options with animated posters available.
                                  </p>
                                ) : (
                                  <CustomPostSelector
                                    images={selectorOptions}
                                    selected={this.state.selectedOption}
                                    setSelected={(selected) =>
                                      this.setState({ selectedOption: selected })
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer p-0 border-0">
                      <Button
                        type="button"
                        className="button-warning--modal p-1 mr-2"
                        onClick={this.cancelModal}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="button-success--modal p-1"
                        disabled={isSubmitting || !this.state.selectedOption}
                      >
                        Generate Ani Poster
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AniPosterModal;
